import { Button, Dialog } from 'primereact'
import React, { useContext, useRef } from 'react'
import { useState } from 'react';
import { formatDate } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import CrearSolicitudMotorista from '../new/CrearSolicitudMotorista'
import interactionPlugin from '@fullcalendar/interaction';
import { ProgMotoristasContext } from '../../../../context/ProgramacionMotoristas/MotoristasContext';
import { useEffect } from 'react';

const CalendarProgramacionMotoristas = ({ showCalendar, onHide }) => {


  const [progMoto, setProgMoto] = useState([]);

  const EditingStateRef = useRef(null);
  const toast = useRef(null)
  const Calendar = useRef(null);

  const [data, setData] = useState([
    { id: 1, title: 'event 1', start: '2023-06-01', end: '2023-06-04' },
    { id: 2, title: 'event 2', start: '2023-06-02', end: '2023-06-04'}
  ]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [edit, setEdit] = useState(null);


  let eventGuid = 0
  let todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today
  const [state, setState] = useState({
    weekendsVisible: true,
    currentEvents: [
      { id: 1, title: 'event 1', start: '2023-06-01', end: '2023-06-04' },
      { id: 2, title: 'event 2', start: '2023-06-02', end: '2023-06-04'},
      { id: 2, title: 'event 2', start: '2023-06-06'}
    ]
  })

  function renderSidebarEvent(event) {
    return (
      <li key={event.id}>
        <b>{formatDate(event.start, { year: 'numeric', month: 'short', day: 'numeric' })}</b>
        <i>{event.title}</i>
      </li>
    )
  }

  const handleWeekendsToggle = () => {
    setState({
      weekendsVisible: !this.state.weekendsVisible
    })
  }


  function renderEventContent(eventInfo) {
    // console.log(eventInfo);
    const [fil] = progMoto.filter(e => e.IdProgramacion == eventInfo.event.id)
    // console.log(fil);
    return (
      <div className='demo-app-sidebar col-12' style={{ overflow: 'hidden' }} >
        <div className='p-1 col-12' style={{  }}>
          <span style={{  textOverflow: 'ellipsis' }}>{eventInfo.event.title}</span><br/>
          <span>{fil?.StatusName}</span><br/>
          <span>{fil?.Direccion}</span>

        </div>

        {/* <div className='demo-app-sidebar-section'>
          <h2>Instructions</h2>
          <ul>
            <li>Select dates and you will be prompted to create a new event</li>
            <li>Drag, drop, and resize events</li>
            <li>Click an event to delete it</li>
          </ul>
        </div>
        <div className='demo-app-sidebar-section'>
          <label>
            <input
              type='checkbox'
              checked={state.weekendsVisible}
              onChange={handleWeekendsToggle}
            ></input>
            toggle weekends
          </label>
        </div>
        <div className='demo-app-sidebar-section'>
          <h2>All Events ({state.currentEvents.length})</h2>
          <ul>
            {state.currentEvents.map(renderSidebarEvent)}
          </ul>
        </div> */}
      </div>
    )
  }

  const addEvent = () => {
    // console.log(Calendar.current);
  }

  const handleDateSelect = (selectInfo) => {
    setShowNew(true)
    // let title = prompt('Please enter a new title for your event')
    // let calendarApi = selectInfo.view.calendar

    // calendarApi.unselect() // clear date selection

    // if (title) {
    //   calendarApi.addEvent({
    //     id: createEventId(),
    //     title,
    //     start: selectInfo.startStr,
    //     end: selectInfo.endStr,
    //     allDay: selectInfo.allDay
    //   })
    // }
  }

  const INITIAL_EVENTS = [
    {
      id: createEventId(),
      title: 'All-day event',
      start: todayStr
    },
    {
      id: createEventId(),
      title: 'Timed event',
      start: todayStr + 'T12:00:00'
    }
  ]

  function createEventId() {
    return String(eventGuid++)
  }

  const handleEventClick = (clickInfo) => {
    // console.log(clickInfo.event.id);
    const a = data.filter(e => e.id == clickInfo.event.id)
    console.log(a);
    setEdit(a[0])
    setShowNew(true)


    // if ((`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
    //   clickInfo.event.remove()
    // }
  }

  const handleEvents = (events) => {
    console.log(events);
    // setState({
    //   currentEvents: events
    // })
  }

  const onHideNew = () => {
    setShowNew(false);
    setEdit(null);
  }


  useEffect(() => {
    // console.log(progMoto);
  }, [progMoto])




  return (
    <div>
      <CrearSolicitudMotorista showDialog={showNew} onHide={onHideNew} toast={toast} edit={edit} />
      <Dialog visible={showCalendar} onHide={onHide} maximizable>
        <div style={{ width: '90vw', }}>
          <Button onClick={addEvent} />

          <FullCalendar
            ref={Calendar}
            events={progMoto}
            plugins={[timeGridPlugin, dayGridPlugin, listPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            // businessHours={true}
            eventDurationEditable={true}
            eventContent={renderEventContent}
            weekends={state.weekendsVisible}
            // select={handleDateSelect}
            // eventClick={handleEventClick}
            // eventsSet={handleEvents}
            headerToolbar= {{ 
              start: 'title',
              center: 'dayGridMonth,dayGridWeek,dayGridDay,dayGrid, dayGridMonth,timeGridWeek,timeGridDay,listMonth,listWeek',
              end: 'today prev,next'
             }}
          />

        </div>
      </Dialog>
    </div>
  )
}

export default CalendarProgramacionMotoristas